import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import { useDeleteCategoryAccessPolicyMutation } from '../../../../api/services/categoryAccessPolicyApi'
import NewModal from '../../../root/modals/NewModal'

const DeleteCategoryAccessPolicyModal = ({ open, onClose, policyId }) => {
  const { t } = useTranslation()
  const [deletePolicy] = useDeleteCategoryAccessPolicyMutation()

  return (
    <NewModal
      closeModal={onClose}
      showModal={open}
      title={t('delete_policy')}
      hideClose
      btns
      noChildren
      titleClose={t('close')}
      titleSubmit={t('delete')}
      onClickClose={onClose}
      onClickSubmit={async () => {
        try {
          const response = await deletePolicy(policyId).unwrap()
          toast.success(response.message)
          onClose()
        } catch (error) {
          toast.error(error.data?.message || t('err_occ'))
        }
      }}
    />
  )
}

export default DeleteCategoryAccessPolicyModal
